import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { copy } from "../data/content";
import { scrollToId, scrollToTop } from "../lib/scroll";

export const Navbar = () => {
  const { lang, toggle, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => scrollToId(id);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled
          ? "bg-[#F9F9F8]/85 backdrop-blur-md border-[#E5E5E5]"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToTop()}
          className="font-['IBM_Plex_Mono'] text-xs md:text-sm tracking-[0.2em] uppercase text-[#111111] focus:outline-none focus:ring-1 focus:ring-black focus:ring-offset-2"
        >
          Forschungssoftware
        </button>

        <nav className="hidden md:flex items-center gap-10 font-['IBM_Plex_Mono'] text-xs tracking-[0.15em] uppercase text-[#555555]">
          {[
            { id: "products", label: copy.nav.products },
            { id: "contact", label: copy.nav.contact },
          ].map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollTo(item.id)}
              className="group relative py-1 focus:outline-none"
            >
              <span className="transition-colors duration-300 group-hover:text-[#111111]">
                {t(item.label)}
              </span>
              <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-[#111111] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <button
          data-testid="btn-language-toggle"
          onClick={toggle}
          aria-label="Toggle language"
          className="font-['IBM_Plex_Mono'] text-xs tracking-[0.15em] border border-[#111111] px-3 py-1.5 flex items-center gap-1 focus:outline-none focus:ring-1 focus:ring-black focus:ring-offset-2 hover:bg-[#111111] hover:text-[#F9F9F8] transition-colors duration-300"
        >
          <span className={lang === "DE" ? "font-medium" : "text-[#999999]"}>DE</span>
          <span className="text-[#999999]">/</span>
          <span className={lang === "EN" ? "font-medium" : "text-[#999999]"}>EN</span>
        </button>
      </div>
    </motion.header>
  );
};
